module.exports = __webpack_public_path__ + "ipetbooking/admin/img/lineFriend_2.406274ae.jpg";